import { AddShippingAddress as AddShippingAddressShared } from '../../../../components/Containers/ReviewCheckoutDrawer/ShippingAddress/AddShippingAddress';
import { useFlow } from '../../../../providers';
import { usePreAuthOfferCtx } from '../../../../providers/PreAuthOfferProvider';

export const AddShippingAddress = () => {
  const { handleAddressUpdate } = usePreAuthOfferCtx();
  const { goToStep } = useFlow();
  return (
    <AddShippingAddressShared
      onAddressUpdate={async (addressId) => {
        await handleAddressUpdate(addressId);
        goToStep('review');
      }}
    />
  );
};
